<template>
  <div class="box">
    <div class="performance">
      <div class="content">
        <div class="hearder">
          <el-date-picker
            v-model="valueTime"
            type="month"
            placeholder="选择日期"
            :picker-options="setDisabled"
            @change="searchChange"
          >
          </el-date-picker>
        </div>
        <div class="tableList">
          <el-table border :data="tableDate">
            <el-table-column
              prop="fieldTime"
              label="日期"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="fieldDays"
              label="外勤"
              align="center"
            ></el-table-column>
          </el-table>
          <div class="message">
            <span>*</span
            >如有数据缺失，请及时更新分享销客外勤登记，数据将于次日同步更新
          </div>
        </div>
      </div>
      <div class="footer">数据更新日期：{{ flshTime ? flshTime : "暂无" }}</div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis/fieldPersonnelSearch";
import { getToken } from "@/utils/cookie";
export default {
  name: "performance",
  components: {},
  data() {
    return {
      // valueTime: new Date(),
      // valueTime默认取上月
      valueTime: moment(new Date()).subtract(1, "month").format("YYYY-MM"),
      setDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now(); // 可选历史天、不可选将来天
        },
      },
      tableDate: [],
      flshTime: "",
    };
  },
  mounted() {
    let token = getToken();
    if (token) {
      this.getList(token);
    } else {
      this.$bus.$on("processToken", (res) => {
        this.getList(res);
      });
    }
    // this.getList();
  },
  methods: {
    //搜索
    searchChange() {
      this.getList();
    },
    //获取表格数据
    getList(token) {
      api
        .queryFieldDetail({
          empNum: token,
          empName: "",
          page: 1,
          pageSize: 999,
          startTime: this.valueTime
            ? moment(this.valueTime).format("YYYY-MM-01")
            : "",
          endTime: this.valueTime
            ? moment(this.valueTime, "YYYY-MM")
                .endOf("month")
                .format("YYYY-MM-DD")
            : "",
        })
        .then((res) => {
          if (res.code == 200) {
            this.tableDate = res.data.list;
            if (this.tableDate.length > 0) {
              this.flshTime = res.data.list[res.data.list.length - 1].creTime;
              const totalFieldDays = this.tableDate.reduce((sum, item) => {
                return sum + (item.fieldDays || 0);
              }, 0);
              this.tableDate.push({
                fieldTime: "合计",
                fieldDays: totalFieldDays,
              });
            }
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .performance {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .performance {
    width: 276px * $zoom;
  }
}

.box {
  width: 100%;
  display: flex;
  justify-content: center;
}

.performance {
  font-size: 12px * $zoom;
  min-height: 100vh;
  background: #f7f9fa;
  position: relative;
  .content {
    width: 100%;
    height: calc(100vh - 100px);
    background: #fff;
    position: relative;
    overflow: auto;
    padding-bottom: 30px;
  }
  .hearder {
    height: 134px;
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 30px;
    ::v-deep {
      .el-input__inner {
        height: 67px;
        width: 180px;
      }
      .el-input--mini .el-input__icon {
        line-height: 65px;
      }
      .el-date-editor {
        width: 220px;
        margin-left: 30px;
        .el-input__inner {
          height: 67px;
          width: 220px;
        }
      }
    }
  }
  .tableList {
    padding: 0 30px 10px;
    ::v-deep {
      thead {
        tr {
          th {
            background: #f7f9fa;
            font-weight: bold;
            color: #000;
          }
        }
      }
      tbody {
        tr:last-child {
          td {
            background: #f7f9fa;
          }
          td:nth-child(1) {
            border-right: none;
            color: #000;
            font-weight: bold;
          }
          td:nth-child(2) {
            color: #ff5265;
            font-weight: bold;
          }
        }
      }
    }
    .message {
      margin-top: 30px;
      font-size: 28px;
      color: #666666;
      span {
        color: #ff5265;
        margin-right: 10px;
      }
    }
  }
  .footer {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: #999999;
  }
}
</style>
